import { env } from '../helper/environment.helper';

export const API_BASE_PATH = env('REACT_APP_API_BASE_PATH');
